import { createUseStyles } from 'react-jss';

export const addEditOnCall = createUseStyles({
  container: {

  },
});
